import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Navbar from '../../../Components/Navbar'
import Footer from '../../../Components/Footer'
import Container from 'react-bootstrap/Container'
import { Redirect } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import '../wallet.css'
import '../BrlDepResWallet/brlDepRes.css'
import InsideMenu from '../../../Components/InsideMenu'

class TransacaoNotFound extends PureComponent {
    constructor(props) {
    super(props)
    this.state = {
        
    }}



        render() {

            const { logged, userLogged } = this.props
    
            return (
    
                <>
                    <Navbar loggedArea={true} />
                    {!logged ? <Redirect to="/login" /> : userLogged.cpf === null || userLogged.cep === null ? <Redirect to="/finalizar-cadastro" /> :  
                        <div className="section minhaContaWrapper">
                        <Container>
                                <div className="section">
                                    <Row>
                                        <Col md={12}>
                                            <InsideMenu />    
                                        </Col>
                                    </Row>
                                </div>

                                <div className="section insideSec">
                                    <Row>
                                        <Col md={12} className="d-flex flex-column align-items-center">
                                            <h1 className="display-4 tx-pink">404</h1>
                                            <h3 className="tx-pink">Transação não encontrada</h3>
                                            <div className="d-flex btnDetailWrapper justify-content-between mt-5">
                                                <Link to="/wallet/extrato" className="btnDetail btnDetailBack" style={{width: '100%'}}>Voltar</Link>
                                            </div>
                                        </Col>
                                    </Row>
                                
                                </div>
                            </Container>
                        </div>                        
                    }
                    {/* <Footer /> */}
                </>
            )
        }
    }

const mapStateToProps = state => ({
    logged: state.login.logged,
    userLogged: state.users.userLogged,
})
    
const mapDispatchToProps = dispatch => ({
    
})

export default connect(mapStateToProps, mapDispatchToProps)(TransacaoNotFound)